export const highlightMatches = (text, searchQuery) => {
  if (!searchQuery || !text || text === '-') {
    return text
  }

  const query = searchQuery.trim()
  if (!query) {
    return text
  }

  // Escape special regex characters
  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const regex = new RegExp(`(${escapedQuery})`, 'gi')
  
  return text.replace(regex, '<mark class="bg-yellow-200 dark:bg-yellow-800 px-1 rounded">$1</mark>')
}

export const debounce = (func, delay) => {
  let timeoutId
  return (...args) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => func.apply(null, args), delay)
  }
}

export const formatBankCode = (code) => {
  return code.padStart(3, '0')
}

export const sortBanks = (banks, field, direction) => {
  return [...banks].sort((a, b) => {
    let valueA, valueB

    switch (field) {
      case 'code':
        valueA = parseInt(a.code)
        valueB = parseInt(b.code)
        break
      case 'nameEn':
        valueA = a.nameEn.toLowerCase()
        valueB = b.nameEn.toLowerCase()
        break
      case 'nameZh':
        valueA = a.nameZh !== '-' ? a.nameZh.toLowerCase() : 'zzz'
        valueB = b.nameZh !== '-' ? b.nameZh.toLowerCase() : 'zzz'
        break
      default:
        return 0
    }

    if (direction === 'asc') {
      return valueA > valueB ? 1 : -1
    } else {
      return valueA < valueB ? 1 : -1
    }
  })
}